import {Helmet} from "react-helmet"
import HomepagePatient from "./HomepagePatient";


const about = () => {
	
	return <>
		<Helmet>
			<title>About Us</title>
		</Helmet>
		<HomepagePatient publicView about/>
		</>
	

}
export default about
